/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* Judge.me */
window.addEventListener('load', (event) => {
  let judgmeWrite = document.querySelector('.jdgm-write-rev-link');
  if (judgmeWrite) {
    judgmeWrite.addEventListener('click', () => {
      let fieltSet = document.querySelectorAll('.jdgm-form__fieldset')[3]
      fieltSet.querySelector('label').textContent = 'Image/Vidéo (facultatif)'
    })
  }
})

/* AXEPTIO AJOUT DELAY */
let axeptioMount = document.querySelector('.axeptio_mount');

if (axeptioMount) {
  setTimeout(function () {
    axeptioMount.style.cssText = 'display: block;'
  }, 10000)
}
/* CART DRAWER CLICK VARIANT */

function drawerVariant(element) {
  var width_screen = window.innerWidth
  // Desktop
  if (width_screen > 741) {
    var id_drawer = element.getAttribute('aria-controls')
    setTimeout(function () {
      if (!!document.querySelector('#' + id_drawer + ' .color-swatch__item') === true && !!document.querySelector('#' + id_drawer + ' .combo-box__option-list button.combo-box__option-item') === true) {
        var variant_label = document.querySelectorAll('#' + id_drawer + ' .color-swatch__item')
        for (var i = 0; i < variant_label.length; i++) {
          variant_label[i].addEventListener('click', function (event) {
            var name_product = document.querySelector('#' + id_drawer + ' .select__selected-value').innerHTML.replaceAll('&amp;', '&')
            var name_variant = event.target.children[0].innerHTML
            var selection_img_produit = name_product + ' / ' + name_variant
            var img_src = document.querySelector('data[drawer-product-id="' + id_drawer + '"] span[title="' + selection_img_produit + '"]').getAttribute('variant-img-src')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').removeAttribute('srcset')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').setAttribute('src', img_src)
          })
        }
        var variant_select = document.querySelectorAll('#' + id_drawer + ' .combo-box__option-list button.combo-box__option-item')
        for (var i = 0; i < variant_select.length; i++) {
          variant_select[i].addEventListener('click', function (event) {
            setTimeout(function () {
              var name_product = event.target.innerHTML.replaceAll('&amp;', '&')
              var name_variant = document.querySelector('#' + id_drawer + ' .product-form__option-info .product-form__option-value').innerHTML
              var selection_img_produit = name_product + ' / ' + name_variant
              var img_src = document.querySelector('data[drawer-product-id="' + id_drawer + '"] span[title="' + selection_img_produit + '"]').getAttribute('variant-img-src')
              document.querySelector('#' + id_drawer + ' .quick-buy-product__image').removeAttribute('srcset')
              document.querySelector('#' + id_drawer + ' .quick-buy-product__image').setAttribute('src', img_src)
            }, 200)
          })
        }
      } else if (!!document.querySelector('#' + id_drawer + ' .color-swatch__item') === true) {
        var variant_label = document.querySelectorAll('#' + id_drawer + ' .color-swatch__item')
        for (var i = 0; i < variant_label.length; i++) {
          variant_label[i].addEventListener('click', function (event) {
            var name_variant = event.target.children[0].innerHTML
            var img_src = document.querySelector('data[drawer-product-id="' + id_drawer + '"] span[title="' + name_variant + '"]').getAttribute('variant-img-src')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').removeAttribute('srcset')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').setAttribute('src', img_src)
          })
        }
      } else if (!!document.querySelector('#' + id_drawer + ' .combo-box__option-list button.combo-box__option-item') === true) {
        var variant_select = document.querySelectorAll('#' + id_drawer + ' .combo-box__option-list button.combo-box__option-item')
        for (var i = 0; i < variant_select.length; i++) {
          variant_select[i].addEventListener('click', function (event) {
            var name_product = event.target.innerHTML.replaceAll('&amp;', '&')
            var img_src = document.querySelector('data[drawer-product-id="' + id_drawer + '"] span[title="' + name_product + '"]').getAttribute('variant-img-src')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').removeAttribute('srcset')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').setAttribute('src', img_src)
          })
        }
      }
    }, 1500)

    // Mobile
  } else {
    var id_drawer = element.getAttribute('aria-controls')
    setTimeout(function () {
      if (!!document.querySelector('#' + id_drawer + ' .color-swatch__item') === true && !!document.querySelector('#' + id_drawer + ' .combo-box__option-list button.combo-box__option-item') === true) {
        var variant_label = document.querySelectorAll('#' + id_drawer + ' .color-swatch__item')
        for (var i = 0; i < variant_label.length; i++) {
          variant_label[i].addEventListener('click', function (event) {
            var name_product = document.querySelector('#' + id_drawer + ' .select__selected-value').innerHTML.replaceAll('&amp;', '&')
            var name_variant = event.target.children[0].innerHTML
            var selection_img_produit = name_product + ' / ' + name_variant
            var img_src = document.querySelector('data[popover-product-id="' + id_drawer + '"] span[title="' + selection_img_produit + '"]').getAttribute('variant-img-src')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').removeAttribute('srcset')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').setAttribute('src', img_src)
          })
        }
        var variant_select = document.querySelectorAll('#' + id_drawer + ' .combo-box__option-list button.combo-box__option-item')
        for (var i = 0; i < variant_select.length; i++) {
          variant_select[i].addEventListener('click', function (event) {
            setTimeout(function () {
              var name_product = event.target.innerHTML.replaceAll('&amp;', '&')
              var name_variant = document.querySelector('#' + id_drawer + ' .product-form__option-info .product-form__option-value').innerHTML
              var selection_img_produit = name_product + ' / ' + name_variant
              var img_src = document.querySelector('data[popover-product-id="' + id_drawer + '"] span[title="' + selection_img_produit + '"]').getAttribute('variant-img-src')
              document.querySelector('#' + id_drawer + ' .quick-buy-product__image').removeAttribute('srcset')
              document.querySelector('#' + id_drawer + ' .quick-buy-product__image').setAttribute('src', img_src)
            }, 200)
          })
        }
      } else if (!!document.querySelector('#' + id_drawer + ' .color-swatch__item') === true) {
        var variant_label = document.querySelectorAll('#' + id_drawer + ' .color-swatch__item')
        for (var i = 0; i < variant_label.length; i++) {
          variant_label[i].addEventListener('click', function (event) {
            var name_variant = event.target.children[0].innerHTML
            var img_src = document.querySelector('data[popover-product-id="' + id_drawer + '"] span[title="' + name_variant + '"]').getAttribute('variant-img-src')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').removeAttribute('srcset')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').setAttribute('src', img_src)
          })
        }
      } else if (!!document.querySelector('#' + id_drawer + ' .combo-box__option-list button.combo-box__option-item') === true) {
        var variant_select = document.querySelectorAll('#' + id_drawer + ' .combo-box__option-list button.combo-box__option-item')
        for (var i = 0; i < variant_select.length; i++) {
          variant_select[i].addEventListener('click', function (event) {
            var name_product = event.target.innerHTML.replaceAll('&amp;', '&')
            var img_src = document.querySelector('data[popover-product-id="' + id_drawer + '"] span[title="' + name_product + '"]').getAttribute('variant-img-src')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').removeAttribute('srcset')
            document.querySelector('#' + id_drawer + ' .quick-buy-product__image').setAttribute('src', img_src)
          })
        }
      }
    }, 1500)
  }
}

/* Solution secours problème de color swatch */
setTimeout(function () {
  if (!!document.querySelector('.product__info>.product-form .color-swatch__item') === true) {
    var label_product = document.querySelectorAll('.product-form .color-swatch__item')
    for (var i = 0; i < label_product.length; i++) {
      label_product[i].addEventListener('click', function (event) {
        var label_variant_name = event.target.children[0].innerHTML
        document.querySelector('.product__thumbnail img[alt*="' + label_variant_name + '"]').click()
      })
    }
    document.querySelector('.product__info>.product-form .color-swatch:not(.is-disabled) .color-swatch__item').click()
  }
}, 100)

/** inga-cart-recommendations componenents  */

const IngaCartRecommendations = class extends HTMLElement {
  get url() {
    return this.dataset.url
  }
  async connectedCallback() {
    if (!IngaCartRecommendations.cache[this.url]) {
      IngaCartRecommendations.cache[this.url] = await (await fetch(this.url)).text()
    }

    const div = document.createElement('div')
    div.innerHTML = IngaCartRecommendations.cache[this.url]

    const cartRecommendationsElement = div.querySelector('inga-cart-recommendations')

    if (cartRecommendationsElement && cartRecommendationsElement.hasChildNodes()) {
      this.innerHTML = cartRecommendationsElement.innerHTML
    }

    this.initPagination()
  }
  initPagination() {
    this.slider = document.querySelector('.inga-cart-recommendations__list')
    this.prevButton = document.querySelector('[data-cart-recommendations-scroller-prev]')
    this.nextButton = document.querySelector('[data-cart-recommendations-scroller-next]')
    this.dots = document.querySelectorAll('.inga-cart-recommendations__dots__unit')
    this.currentIndex = 0
    if (this.slider && this.prevButton && this.nextButton && this.dots.length > 0) {
      this.prevButton.addEventListener('click', () => {
        this.slide('prev')
      })
      this.nextButton.addEventListener('click', () => {
        this.slide('next')
      })
      this.dots.forEach((dot) => {
        dot.addEventListener('click', this.handleDotClick.bind(this))
        dot.addEventListener('touch', this.handleDotClick.bind(this))
      })
    }
  }

  handleDotClick(e) {
    const dot = e.currentTarget
    const dotPosition = parseInt(dot.dataset.position)
    if (dotPosition === this.currentIndex) return
    this.currentIndex = dotPosition
    this.changeActiveDot()
    this.slider.scroll({
      left: this.slider.clientWidth * this.currentIndex,
      behavior: 'smooth',
    })
  }
  slide(direction) {
    let left
    const clientWidth = this.slider.clientWidth
    const scrollLeft = this.slider.scrollLeft

    switch (direction) {
      case 'prev':
        left = scrollLeft - clientWidth
        if (this.currentIndex > 0) {
          this.currentIndex--
        }
        break
      case 'next':
      default:
        left = scrollLeft + clientWidth
        if (this.currentIndex < this.dots.length - 1) {
          this.currentIndex++
        }
        break
    }
    this.changeActiveDot()

    this.slider.scroll({
      left,
      behavior: 'smooth',
    })
  }
  changeActiveDot() {
    this.dots.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.add('inga-cart-recommendations__dots__unit--active')
      } else {
        dot.classList.remove('inga-cart-recommendations__dots__unit--active')
      }
    })
  }
}
Object.defineProperty(IngaCartRecommendations, 'cache', { value: {} })

window.customElements.define('inga-cart-recommendations', IngaCartRecommendations)

// window.addEventListener('load', () => {
//   const urlId = window.location.hash;
//   const sectionWithUrlId = document.getElementById(urlId.substring(1));

//   if (urlId) {
//       setTimeout(function () {
//         if (sectionWithUrlId) {
//           sectionWithUrlId.scrollIntoView({ behavior: "smooth", block: "center" });
//         }
//       }, 400);
//     }
// });

// ==================== SECTION : STICKY VIDEO ==================== //

class StickyVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.closeButton = this.querySelector(".section-svideo-close-button");
    this.videoWrapper = this.querySelector(".section-svideo-wrapper");
    this.videoElement = this.videoWrapper.firstElementChild;
    this.appearAfterScroll = this.hasAttribute('appearAfterScroll');
    this.position = this.getAttribute('position');
    this.roundSize = parseInt(this.getAttribute('roundSize'));
    this.enlargedVideoSize = parseInt(this.getAttribute('enlargedVideoSize'));
    this.enlargedVideoSizeMobile = parseInt(this.getAttribute('enlargedVideoSizeMobile'));
    this.handleScrollAppear = this.handleScrollAppear.bind(this);

    this.addEventListeners();
    this.applyPositionStyles();
  }

  addEventListeners() {
    this.closeButton.addEventListener("click", () => this.handleClickClose());
    this.videoWrapper.addEventListener("click", () => this.handleClickVideo());
    this.videoElement.addEventListener("click", (e) => e.preventDefault()); // Prevent video pause on enlargement 
    this.appearAfterScroll ? window.addEventListener("scroll", this.handleScrollAppear) : this.style.display = "block";
  }

  applyPositionStyles() {
    switch (this.position) {
      case 'left':
        this.style.left = "24px";
        break;
      case 'right':
        this.style.right = "24px";
        break;
      default:
        this.style.left = `calc(50% - ${this.roundSize / 2}px)`;
    }
  }

  handleScrollAppear() {
    var wHeight = window.innerHeight;
    var y = window.scrollY;
    if (y >= wHeight / 2)
      this.style.display = "block"
  }

  // When you click on the mini video to enlarge
  handleClickVideo() {

    if (window.matchMedia("(max-width: 750px)").matches)
      var newWidth = this.enlargedVideoSizeMobile;
    else
      var newWidth = this.enlargedVideoSize;

    this.style.width = `${newWidth}%`;
    this.style.height = 'auto';
    this.videoWrapper.classList.remove("section-svideo-round");
    this.videoWrapper.classList.add("section-svideo-enlarged");
    this.videoElement.style.width = "100%";

    // Video player elements
    this.videoElement.currentTime = 0;
    this.videoElement.setAttribute("controls", "controls")
    this.videoElement.muted = false;
    this.videoElement.volume = 1;
    this.videoElement.removeAttribute("muted");

    if (this.position == "center")
      this.style.left = `calc(50% - ${this.enlargedVideoSize / 2}%)`;
  }

  // When you click on the close button -> shrink or hide
  handleClickClose() {
    if (this.videoWrapper.classList.contains("section-svideo-enlarged")) {

      //Animation from height auto to fixed
      const sectionContainerHeight = this.clientHeight;
      this.style.height = `${sectionContainerHeight}px`;

      requestAnimationFrame(() => {
        this.style.height = `${this.roundSize}px`;
      });

      this.style.width = `${this.roundSize}px`;
      this.videoWrapper.classList.remove("section-svideo-enlarged");
      this.videoWrapper.classList.add("section-svideo-round");
      this.videoElement.style.removeProperty('width');

      // Video player elements
      this.videoElement.removeAttribute("controls");
      this.videoElement.volume = 0;
      this.videoElement.setAttribute("muted", "muted");

      if (this.position == "center")
        this.style.left = `calc(50% - ${this.roundSize / 2}px)`;
    }
    else {
      this.style.display = "none";
      window.removeEventListener("scroll", this.handleScrollAppear);
    }
  }
}

customElements.define('sticky-video', StickyVideo);

class CartProgressBars extends HTMLElement {
  constructor(){
    super();

    this.progressBars = this.querySelectorAll('progress');

  }

  connectedCallback(){
    this.setProgressBars();
  }

  setProgressBars(){
    const oldCartTotal = parseFloat(document.body.dataset.cartOldPrice);

    let indexAnimation = 0;

    this.progressBars.forEach((progressBar, index) => {
    const newProgressBarValue = parseFloat(progressBar.dataset.valueTo);
    const progressBarMaxValue = parseFloat(progressBar.getAttribute('max'));
    let oldProgressBarValue;
    
    if(progressBar.dataset.pastedStep){
      oldProgressBarValue = oldCartTotal - parseFloat(progressBar.dataset.pastedStep);
    } else{
      oldProgressBarValue = 0;
    }
    
    progressBar.value = oldProgressBarValue;
    const timeout = indexAnimation * 500;

    if(newProgressBarValue >= progressBarMaxValue){
      progressBar.value = newProgressBarValue;
    } else{
      
      setTimeout(() => {
        progressBar.value = newProgressBarValue;
      }, timeout);

      indexAnimation += 500;
    }

    })
  }

}

customElements.define('cart-progress-bars', CartProgressBars);